<template>
  <loader :loading-promise="loadingPromise">
    <template slot="fulfilled">
      <view-profile :user="user" :albums="albums" :pages="pages" />
    </template>
  </loader>
</template>

<script>
import axios from 'axios'
import Loader from './Loader'
import ViewProfile from './ViewProfile'
export default {
  props: ['id'],
  data() {
    return {
      user: null,
      albums: null,
      pages: null,
      loadingPromise: null,
    }
  },
  mounted() {
    this.loadingPromise = axios.get('/api/users/' + this.$route.params.id, { params: { includeAlbums: true } }).then(response => {
      this.user = response.data.user
      this.albums = response.data.albums
      this.pages = response.data.pages
    })
  },
  components: {
    Loader,
    ViewProfile,
  },
}
</script>

<style lang="stylus" scoped>

</style>
